export enum ImaVpaidMode {
    DISABLED = 'DISABLED', // VPAID ads will not play; an error will be returned.
    ENABLED = 'ENABLED',   // Default; Enabled using x-domain iframe. VPAID ads cannot access the site.
    INSECURE = 'INSECURE'  // Enabled using friendly iframe. Enables VPAID site access via JavaScript.
}

